module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }